/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import Grid from '@mui/material/Grid';

import WidgetDialog from '../components/dialogs';
import ContentContainer from '../components/contentContainer';
import WaitSpinner from '../components/waitspinner';
import TitleHeader from '../components/titleHeader';

import { useStyles } from './styles';
import ImportantOutlook from './importantOutlook.jsx';
import useWidgetTheme from '../../commons/widgetTheme';
import TranslationIds from '../../commons/translationIds';
import useTranslator from '../../commons/translations';
import getCommonUIStyles from '../../commons/uiStyles';
import useICSLink from '../icslink/useICSLink';
import CommonImages from '../../commons/images/index.js';
import { useAppStore } from '../../store/models/app/index.js';

function OutlookNewGuide (props) {
    const  {
        translate,
        translateWithValues,
    } = useTranslator();

    const {
        widget,
        widgetTheme,
    }  = useWidgetTheme();
   
    const appStore = useAppStore();

    const {
        inProgress,
        selectedCalendar,
        subuscriberStatus,
    } = useICSLink();

    const classes = useStyles({
        inProgress,
        widget,
        widgetTheme,
        commonUIStyles: getCommonUIStyles({ widgetTheme, widget }),
    });
    
    useEffect(() => {
        
        appStore.openDeviceCalendar(selectedCalendar);
        subuscriberStatus();
    }, []);


    return (
        <React.Fragment>
            <ContentContainer>
                <WidgetDialog
                    goToBackPage={() => {
                        appStore.gotoICSLinkOutlook();
                    }}
                >
                    <TitleHeader
                        widget={widget}
                        widgetTheme={widgetTheme}
                        title={`${translate(TranslationIds.CALENDAR_PROC_TITLE)}`}
                        subtitle={''}
                    />

                    <Grid className={classes.body}>
                        <Grid className={classNames([classes.guideBody])}>

                            <Grid className={classes.banner}>
                                <img
                                    alt='guide-banner'
                                    className={classes.bannerImage}
                                    src={CommonImages.OUTLOOK_NEW_GUIDE}
                                />
                            </Grid>

                            <Grid className={classes.spinnerBox}>
                                <WaitSpinner
                                    visible={true}
                                    commonUIStyles={getCommonUIStyles({ widgetTheme, widget })}
                                    text={translate(TranslationIds.CALENDAR_PROC_SPINNER)}
                                />
                            </Grid>

                            <Grid className={classNames([classes.bodyMessages])}>
                                { translateWithValues(TranslationIds.SYMPLY_CLICK_PROC, { calendar: selectedCalendar })}
                            </Grid>

                            <ImportantOutlook />
                        </Grid>
                    </Grid>

                </WidgetDialog>
            </ContentContainer>           
        </React.Fragment>
    );
}

/*
    <strong>Important:</strong>
*/

OutlookNewGuide.propTypes = {
    text: PropTypes.string,
};

export default observer(OutlookNewGuide);